import type { ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { outdatedRowVersion, useProductVersionStore } from '@/store/productVersionStore';

/** Editorbediening bij de productnaam; nooit onderdeel van opgeslagen klantinhoud. */
export default function ProductRowVersionFlag({
  productId,
  productVersionId,
  onSelect,
  children,
}: {
  productId: string | null | undefined;
  productVersionId: string | null | undefined;
  onSelect: () => void;
  children?: ReactNode;
}) {
  const versions = useProductVersionStore();
  const version = outdatedRowVersion(versions, productId, productVersionId);
  if (!version) return null;
  const label = `Nieuwere productversie: ${version.usedVersion != null ? `v${version.usedVersion} → ` : ''}v${version.version}`;
  const trigger = (
    <button
      type="button"
      className="product-row-version-flag"
      aria-label={label}
      title={label}
      onPointerDown={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.stopPropagation();
        onSelect();
      }}
    >
      <TriangleAlert size={14} aria-hidden="true" />
      <span>
        {version.usedVersion != null ? `v${version.usedVersion} → ` : ''}v{version.version}
      </span>
    </button>
  );
  return (
    <span data-html2canvas-ignore="true" className="product-row-version-control">
      {children ? (
        <Popover>
          <PopoverTrigger asChild>{trigger}</PopoverTrigger>
          <PopoverContent
            data-investment-inspector
            align="start"
            sideOffset={6}
            className="w-80 max-w-[calc(100vw-24px)]"
            onPointerDown={(event) => event.stopPropagation()}
            onClick={(event) => event.stopPropagation()}
          >
            {children}
          </PopoverContent>
        </Popover>
      ) : (
        trigger
      )}
    </span>
  );
}
